import { FormFieldTypes } from "../../../data/formFieldType";

export const AddVerifiedCompetencyData = {
  name: "ManualAccountTaskList",
  initialState: {
    gmpNumber: "",
    gmpName: "",
    verifiedCompetency: null,
    dateofCertificate: '',
    uploadFile: "",
    internalComments: ""
  },
  formFields: [
    {
      id: "gmpNumber",
      lable: "Enter GMP Number",
      Field_Name: "Enter GMP Number",
      fieldType: FormFieldTypes.INPUT,
      dataField: "gmpNumber",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [ { type: "require" } ],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "gmpName",
      lable: "GMP Name",
      Field_Name: "GMP Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "gmpName",
      fieldSetting: {
        placeholder: "",
        options: [],
        isDisable: true
      },
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "verifiedCompetency",
      lable: "Verified Competency",
      Field_Name: "Verified Competency",
      fieldType: FormFieldTypes.SELECT,
      dataField: "verifiedCompetency",
      fieldSetting: {
        placeholder: " ",
        options: [],
      },
      validation: [ { type: "require" } ],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },

    {
      id: "dateofCertificate",
      lable: "Date of Certificate",
      Field_Name: "Date of Certificate",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "dateofCertificate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
      },
      validation: [ { type: "require" } ],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "uploadFile",
      lable: "Upload Document (please upload in pdf format max 2mb)",
      Field_Name: "Upload File",
      fieldType: FormFieldTypes.FILE,
      dataField: "uploadFile",
      fieldSetting: {
        isDownloadable: true,
        acceptedFiles: ".jpg, .png , .pdf, .jpeg",
        maxFileSizeInKB: 2048,
      },
      validation: [ { type: "require" } ],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "internalComments",
      lable: "Internal Comments",
      Field_Name: "Internal Comments",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "internalComments",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-md-12 mb-2",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};

export const VerifiedCompetencyData = {
  name: "VerifiedCompetencyData",
  initialState: {
    gmpNumber: "",
    gmpName: "",
    verifiedCompetency: 0,
    dateofCertificate: '',
    uploadFile: "",
    internalComments: ""
  },
  formFields: [
    {
      id: "gmpNumber",
      lable: "Enter GMP Number",
      Field_Name: "Enter GMP Number",
      fieldType: FormFieldTypes.INPUT,
      dataField: "gmpNumber",
      fieldSetting: {
        placeholder: "",
        options: [],
        isDisable: true
      },
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "gmpName",
      lable: "GMP Name",
      Field_Name: "GMP Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "gmpName",
      fieldSetting: {
        placeholder: "",
        options: [],
        isDisable: true
      },
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "verifiedCompetency",
      lable: "Verified Competency",
      Field_Name: "Verified Competency",
      fieldType: FormFieldTypes.SELECT,
      dataField: "verifiedCompetency",
      fieldSetting: {
        placeholder: " ",
        options: [],
        isDisable: true
      },
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },

    {
      id: "dateofCertificate",
      lable: "Date of Certificate",
      Field_Name: "Date of Certificate",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "dateofCertificate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        isDisable: false
      },
      // validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "uploadFile",
      lable: "Upload Document (please upload in pdf format max 2mb)",
      Field_Name: "Upload File",
      fieldType: FormFieldTypes.FILE,
      dataField: "uploadFile",
      fieldSetting: {
        isDownloadable: true,
        acceptedFiles: ".jpg, .png , .pdf, .jpeg",
        maxFileSizeInKB: 2048,
      },
      style: {
        containerCss: "col-lg-12 mb-3",
      },
    },
    {
      id: "internalComments",
      lable: "Internal Comments",
      Field_Name: "Internal Comments",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "internalComments",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable: false
      },
      style: {
        containerCss: "col-md-12 mb-2",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};